const columnSettings = {
  name: {
    name: 'name',
    class: 'tablesort-sortable',
    stSort: 'name',
    displayName: 'NUMBER_POOLS_NAME'
  },
  countryCode: {
    name: 'countryCode',
    class: 'tablesort-sortable',
    stSort: 'assignmentSettings.countryCode',
    displayName: 'NUMBER_POOLS_COUNTRY'
  },
  holdNumberOutOfPoolInSeconds: {
    name: 'holdNumberOutOfPoolInSeconds',
    class: 'tablesort-sortable text-right',
    stSort: 'holdNumberOutOfPoolInSeconds',
    displayName: 'NUMBER_POOLS_LOCK',
    rowAlign: 'right'
  },
  totalTimeForNumberOutOfPoolInSeconds: {
    name: 'totalTimeForNumberOutOfPoolInSeconds',
    class: 'tablesort-sortable text-right',
    stSort: 'totalTimeForNumberOutOfPoolInSeconds',
    displayName: 'NUMBER_POOLS_MAX_LOCK',
    rowAlign: 'right'
  },
  poolSize: {
    name: 'poolSize',
    class: 'tablesort-sortable text-right',
    stSort: 'poolSize',
    displayName: 'NUMBER_POOLS_POOL_SIZE',
    rowAlign: 'right'
  },
  impressionsDay: {
    name: 'impressionsDay',
    class: 'tablesort-sortable text-right',
    displayName: 'IMPRESSIONS_DAY',
    stSort: 'poolImpressionsDay',
    rowAlign: 'right'
  },
  missesDay: {
    name: 'missesDay',
    class: 'tablesort-sortable text-right',
    displayName: 'MISSES_DAY',
    stSort: 'poolMissedDay',
    rowAlign: 'right'
  },
  impressionsMonth: {
    name: 'impressionsMonth',
    class: 'tablesort-sortable text-right',
    displayName: 'IMPRESSIONS_MONTH',
    stSort: 'poolImpressionsMonth',
    rowAlign: 'right'
  },
  missesMonth: {
    name: 'missesMonth',
    class: 'tablesort-sortable text-right',
    displayName: 'MISSES_MONTH',
    stSort: 'poolMissedMonth',
    rowAlign: 'right'
  },
  numbersAllocating: {
    name: 'numbersAllocating',
    class: 'tablesort-sortable text-right',
    displayName: 'NUMBER_POOLS_NUMBERS_ALLOCATING',
    stSort: 'numbersAllocating',
    rowAlign: 'right'
  }
};

const defaultColumns = [
  'name',
  'countryCode',
  'holdNumberOutOfPoolInSeconds',
  'totalTimeForNumberOutOfPoolInSeconds',
  'poolSize',
  'impressionsDay',
  'missesDay',
  'impressionsMonth',
  'missesMonth',
  'numbersAllocating',
  'currentCounts'
];

export { columnSettings, defaultColumns };

const numberPoolCacheKey = 'numberPoolCache-';

export default class NumberPoolService {
  /** @ngInject **/
  constructor(
    _, $http, ngAuthSettings, promiseCacheService
  ) {
    this._ = _;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.promiseCacheService = promiseCacheService;
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
    this.defaultColumns = defaultColumns;
    this.columnSettings = columnSettings;
  }

  async getNumberPools(accountId) {
    const url = this.serviceBaseUri + accountId + '/numberpools';
    const response = await this.$http.get(url);

    response.data.numberPools.forEach((numberPool)=> {
      numberPool.numbersAllocating = this.numbersAllocating(numberPool.jobs);
    });
    return response;

  }

  async getNumberPoolsDayStats(accountId) {
    const url = this.serviceBaseUri + accountId + '/stats/numberPools?type=day';
    return this.$http.get(url);
  }

  async getNumberPoolsMonthStats(accountId) {
    const url = this.serviceBaseUri + accountId + '/stats/numberPools?type=month';
    return  this.$http.get(url);
  }

  getNumberPool(accountId, numberPoolId, useCache) {
    const url = this._serviceBaseUrl(accountId, numberPoolId);

    if (useCache) {
      const cacheKey = numberPoolCacheKey + numberPoolId;
      return this.promiseCacheService.getCallWithCachedPromise(cacheKey, url, 10);
    } else {
      return this._getResource(url);
    }
  }

  async _getResource(url) {
    return this.$http.get(url);
  }

  async createNumberPool(accountId, numberPool) {
    const url = this.serviceBaseUri+ accountId + '/numberpools';
    return this.$http.post(url, numberPool);
  }

  async addNumber(accountId, numberPoolId, numberId) {
    const url = this._serviceBaseUrl(accountId, numberPoolId) + '/numbers';
    const data = { numberId: numberId };
    return this.$http.put(url, data);
  }

  async updateNumberPool(accountId, numberPoolId, numberPool) {
    const url = this._serviceBaseUrl(accountId, numberPoolId);
    const data = {
      totalTimeForNumberOutOfPoolInSeconds: numberPool.totalTimeForNumberOutOfPoolInSeconds,
      holdNumberOutOfPoolInSeconds: numberPool.holdNumberOutOfPoolInSeconds,
      name: numberPool.name
    };
    return this.$http.patch(url, data);
  }

  async removeNumber(accountId, numberPoolId, numberId) {
    const url = this._serviceBaseUrl(accountId, numberPoolId) + '/numbers';
    const data = { numberId: numberId };
    return this.$http.delete(url, data);
  }

  async getNumbers(accountId, numberPoolId) {
    const url = this._serviceBaseUrl(accountId, numberPoolId) + '/numbers';
    return this.$http.get(url);
  }

  async allocateMoreNumbers(accountId, numberPoolId, allocation, chargeAccountIfNeeded) {
    const url = this._serviceBaseUrl(accountId, numberPoolId) + '/allocateMoreNumbers';
    const data = { allocation: parseInt(allocation), chargeAccountIfNeeded: chargeAccountIfNeeded };
    return this.$http.put(url, data);
  }

  async attachAffiliate(accountId, numberPoolId, affiliateId) {
    const url = this._serviceBaseUrl(accountId, numberPoolId) + '/affiliate';
    const data = { affiliateId: affiliateId };
    return this.$http.put(url, data);
  }

  numbersAllocating(numberPoolJobs) {
    let remainingAmount = 0;

    if (typeof numberPoolJobs === 'undefined' || numberPoolJobs.length === 0) {
      return remainingAmount;
    } else {
      _.forEach(numberPoolJobs, (job) => {
        remainingAmount = remainingAmount + (job.requestAmount - job.completedAmount);
      });
      return remainingAmount;
    }
  }

  async shrinkPool(accountId, numberPoolId, data) {
    const url = this._serviceBaseUrl(accountId, numberPoolId) + '/shrink';
    return this.$http.post(url, data);
  }

  async getNumberPoolReferences(accountId, numberPoolId) {
    const url = this._serviceBaseUrl(accountId, numberPoolId) + '/InboundReferences';
    return this.$http.get(url);
  }

  async deleteNumberPool(accountId, numberPoolId, force, keepNumbers) {
    const url = this._serviceBaseUrl(accountId, numberPoolId) + '?force=' + force + '&keepNumbers=' + keepNumbers;
    return this.$http.delete(url);
  }

  _serviceBaseUrl(accountId, numberPoolId) {
    return this.serviceBaseUri + accountId + '/numberpools/' + numberPoolId;
  }
}
